import { Navigate } from 'react-router-dom';

export default function Page() {
  return <Navigate to="campaigns" />;
}
